import { Schema } from "effect";

export const ConversationThreadAnalyticsHandoffSource = Schema.Literal(
  "tool-call",
  "handoff-detection",
);
export type ConversationThreadAnalyticsHandoffSource =
  typeof ConversationThreadAnalyticsHandoffSource.Type;
